



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import AppMediumState from "@/models/Settings/AppMediums/AppMediumState";

@Component({ name: 'AppMediumState' })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: AppMediumState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case AppMediumState.Enabled:
                color = "success--text";
                break;
            case AppMediumState.Disabled:
                color = "error--text";
                break;
        }
        return color;
    }

}
